export const formatFixedPoint = ( fp, value ) => {
	if ( value ) {
		return value.toLocaleString(
			'en-us',
			{
				minimumFractionDigits: fp,
				maximumFractionDigits: fp
			}
		);
	}

	return '';
};

export const formatFixedPointInput = ( fp, value ) => {
	if ( value ) {
		return parseFloat( value ).toFixedPoint( fp );
	}

	return '';
};

export const unformatFixedPointInput = ( fp, value ) => {
	if ( value ) {
		return parseFloat( value );
	}

	return '';
};
